import { useDocumentosDeLaObra } from '@/modules/ordenes-servicio/useDocumentosDeLaObra'
import { fecha, pesos } from '@/shared/utilidades/formato'

import estilos from './PaginaCartera.module.css'

/**
 * TODOS LOS PAPELES DE LA OS.
 *
 * Johan: «¿por qué no me deja expandir la OS?… para que pueda ver todas las
 * FEV asociadas a la OS». Sale de fn_documentos_de_la_obra (0231), la misma
 * lista del detalle de la orden: la cotización principal, los adicionales y
 * las facturas de venta enlazadas, cada una con su número, estado y valor.
 *
 * OJO CON EL PREFIJO: en el World Office de MEGA las cotizaciones también
 * llevan «FEV» —«FEV 3006» es una cotización—, así que lo que dice qué es
 * cada papel es la etiqueta (Cotización, Adicional, Factura), no el número.
 */
const ESTADO: Record<string, string> = {
  borrador: 'Borrador',
  pendiente: 'En World Office',
  cotizada: 'Cotizada',
  enviada: 'Espera al cliente',
  aprobada: 'Aceptada',
  rechazada: 'Rechazada',
  fallida: 'Falló',
}

export function DocumentosDeCuenta({
  ordenServicioId,
  soloCotizaciones = false,
}: {
  ordenServicioId: string
  /** En cartera las FEV ya se listan aparte, desde fn_cartera. */
  soloCotizaciones?: boolean
}) {
  const { documentos, cargando } = useDocumentosDeLaObra(ordenServicioId)

  if (cargando) return <p className={estilos.pagosVacio}>Buscando los documentos…</p>
  if (documentos.length === 0) {
    return <p className={estilos.pagosVacio}>Esta OS no tiene documentos todavía.</p>
  }

  const cotizaciones = documentos.filter((d) => d.clase === 'cotizacion')
  const facturas = soloCotizaciones ? [] : documentos.filter((d) => d.clase === 'factura')

  return (
    <ul className={estilos.documentos}>
      {[...cotizaciones, ...facturas].map((d) => (
        <li
          key={`${d.clase}-${d.referencia}`}
          className={`${estilos.documento} ${d.anulado ? estilos.documentoAnulado : ''}`}
        >
          <span
            className={`${estilos.docClase} ${
              d.clase === 'factura' ? estilos.docFactura : estilos.docCotizacion
            }`}
          >
            {d.clase === 'factura' ? 'Factura' : d.es_principal ? 'Cotización' : d.etiqueta}
          </span>
          <span className={estilos.docNumero}>{d.numero}</span>
          <span className={estilos.docEstado}>
            {d.anulado ? 'Anulada' : ESTADO[d.estado] ?? d.estado}
            {d.fecha && <> · {fecha(d.fecha)}</>}
          </span>
          <span className={estilos.docValor}>{d.valor === null ? '—' : pesos(d.valor)}</span>
        </li>
      ))}
    </ul>
  )
}
